import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SIZES } from '../../data/collection';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios-title" className="w-full bg-ivory" data-id="element-160" data-mp="17w3rhg845p22">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 [&>*]:min-w-0 px-5 py-16 sm:px-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16 lg:py-24" data-id="element-161" data-mp="13wl7cmo49i0a">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-162" data-mp="1vnhiniuj3elg">
          <SectionHeading id="beneficios-title" title="Elegí el modelo. Prepará la tela. Empezá a coser." intro="Todo lo que necesitás para pasar de la idea a la máquina, ordenado por volumen y por modelo." data-id="element-163" data-mp="1vkvb3j7n0z38" />
        </div>

        <ol className="divide-y divide-dashed divide-coral/35 border-y border-dashed border-coral/35" data-id="element-164" data-mp="1hmet2w4brm5s">
          <li className="py-8" data-id="element-165" data-mp="b7xi6g08y8hg">
            <h3 className="font-serif text-[1.45rem] font-semibold text-graphite sm:text-[1.65rem]" data-id="element-166" data-mp="b4rpyrwbmqhi">Ampliá tus opciones</h3>
            <p className="mt-2.5 max-w-xl text-[1.06rem] leading-relaxed text-graphite-soft" data-id="element-167" data-mp="1gy8ajbcorozm">
              Vestidos, ranitas, enteritos y conjuntos para coser lo que necesitás: una prenda para estrenar, un regalo
              o tu próxima tanda para vender.
            </p>
          </li>
          <li className="py-8" data-id="element-168" data-mp="1byvq0x9aeu07">
            <h3 className="font-serif text-[1.45rem] font-semibold text-graphite sm:text-[1.65rem]" data-id="element-169" data-mp="1bxsxym08alip">
              Elegí el talle por estatura
            </h3>
            <p className="mt-2.5 max-w-xl text-[1.06rem] leading-relaxed text-graphite-soft" data-id="element-170" data-mp="120o748vfu1vk">
              Diez talles para trabajar con distintas medidas. Los accesorios de cabeza se eligen por contorno de cabeza.
            </p>
            <ul aria-label="Talles por estatura, en centímetros" className="mt-5 flex flex-wrap gap-2" data-id="element-171" data-mp="t7l12ln4gray">
              {SIZES.map(size => <li key={size} className="flex h-10 min-w-[3rem] items-center justify-center rounded-full bg-sage-tint px-3 text-[0.95rem] font-bold tabular-nums text-sage-ink" data-id="element-172" data-mp="ed6op3y2cg59">
                  {size}
                </li>)}
            </ul>
          </li>
          <li className="py-8" data-id="element-173" data-mp="3ml5ywi1sjf58">
            <h3 className="font-serif text-[1.45rem] font-semibold text-graphite sm:text-[1.65rem]" data-id="element-174" data-mp="3mkcwtuds1dtf">
              Tené el molde y la guía a mano
            </h3>
            <p className="mt-2.5 max-w-xl text-[1.06rem] leading-relaxed text-graphite-soft" data-id="element-175" data-mp="j4fm9kbpe3uk">
              Imprimí las piezas en A4, a escala real y con margen de costura de 7 mm, y seguí la confección en el
              manual desde el celular, la tablet o la compu.
            </p>
          </li>
        </ol>
      </div>
    </section>;
}